// actions.js
import { serverCall } from 'utils/serverCall';
import {
  initLibraryRequest,
  addLibrary,
  errorLibraryRequest,
  errorAddLibraryRequest
} from './action';
import apiEndpoints from 'utils/apiList';
import toast from 'react-hot-toast';


export const fetchLibraryList = () => {
  return async (dispatch) => {
    dispatch(initLibraryRequest());
    try {
      const result = await serverCall(`${apiEndpoints.LIBRARY_LIST}`, 'GET', dispatch);
      if (result.success) {
        dispatch(addLibrary(result?.data?.payload));
      } else {
        dispatch(errorLibraryRequest(result.message));
      }
    } catch (error) {
      dispatch(errorLibraryRequest(error.message));
    }
  };
};

export const addNewLibrary = (formData, toggle) => {
  return async (dispatch) => {
    // dispatch(initLibraryRequest());
    try {
      const result = await serverCall(`${apiEndpoints.ADD_LIBRARY}`, 'POST', dispatch, formData);
      console.log('result value', result)
      if (result.success) {
        dispatch(fetchLibraryList());
        toast.success('File uploaded successfully!');
        toggle()
      } else {
        toast.error(result?.message)
        // dispatch(errorAddLibraryRequest(result?.message));
      }
    } catch (error) {
      toast.error(error?.message)
      // dispatch(errorAddLibraryRequest(error?.message));
    }
  };
};

export const deletLibarary = (libraryId, setLoading, toggle) => {
  return async (dispatch) => {
    setLoading(true)
    try {
      const result = await serverCall(`${apiEndpoints.DELETE_LIBRARY}/${libraryId}`, 'POST', dispatch);
      if (result.success) {
        dispatch(fetchLibraryList());
        toast.success('File delete successfully!');
        setLoading(false)
        toggle()
      } else {
        setLoading(false)
        toast.error(result?.message)
        // dispatch(errorAddLibraryRequest(result?.message));
      }
    } catch (error) {
      setLoading(false)
      toast.error(error?.message)
      // dispatch(errorAddLibraryRequest(error?.message));
    }
  };
};